<template>
    <section class="create-order">
        <div class="create-program-step-container bk-orange">
            <div class="create-program-step-container-inner">
                <on-behalf dusk="on-behalf-component" @user-selected="addEmailToNotify"/>
            </div>
        </div>

        <div class="create-program-step-container">
            <div class="create-program-step-container-inner">
                <co-step :step-number="1" step-title="Program Details" content-page="program-detail-help"/>
                <program-details :options="orderDetailsOptions" />
            </div>
        </div>
        <div class="create-program-step-container bk-orange">
            <div class="create-program-step-container-inner">
                <co-step :step-number="2" step-title="Budget and Quotes" content-page="program-budget-help"/>
                <budget :options="orderDetailsOptions" />
            </div>
        </div>
        <div class="create-program-step-container">
            <div class="create-program-step-container-inner">
                <co-step :step-number="3" step-title="Automated Orders" content-page="program-scheduler-help"/>
                <automation />
            </div>
        </div>
        <div class="create-program-step-container bk-orange">
            <div class="create-program-step-container-inner">
                <co-step :step-number="4" step-title="Default Languages" content-page="program-languages-help"/>
                <select-languages
                    dusk="select-languages-component"
                    :user-id="user.id"
                    select-language-options-url="/create-order/select-languages/options"
                />
            </div>
        </div>
        <div class="create-program-step-container">
            <div class="create-program-step-container-inner">
                <co-step :step-number="5" step-title="Delivery Options" content-page="program-delivery-help"/>
                <delivery-options
                    dusk="delivery-options-component"
                    delivery-options-url="/create-order/delivery-options/options"
                />
            </div>
        </div>
        <div class="create-program-step-container bk-orange">
            <div class="create-program-step-container-inner">
                <on-behalf dusk="on-behalf-component" @user-selected="addEmailToNotify"/>
            </div>
        </div>
    </section>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import Budget from "./BudgetQuotes/Budget.vue";
import CoStep from "./Co-Step/CoStep.vue";
import OnBehalf from "./On-Behalf/OnBehalf.vue";
import SelectLanguages from "./Select-Languages/SelectLanguages.vue";
import ProgramDetails from "./Program-Details/ProgramDetails.vue";
import "./style.scss";
import DeliveryOptions from './Delivery-Options/DeliveryOptions.vue';
import Automation from './Automation/Automation.vue';
export default {
    name: "CreateProgram",
    data() {
        return {
            orderDetailsOptions: {
                tags: [],
                types: [],
                order_numbers: [],
                programs: [],
                po_required: 0,
                order_type_required: 0,
                tag_settings: {},
                tag_required: false,
                default_order_type: {},
            },
        };
    },
    beforeMount() {
        //get the options for order details dropdowns
        //@TODO - move this to order details component
        this.getProgramDetailsOptions().then((options) => {
            let {
                tags,
                types,
                order_numbers,
                programs,
                po_required,
                order_type_required,
                tag_settings,
                default_order_type,
            } = options;

            //remove bracket information from order types
            types = types.map((type) => {
                return Object.assign({}, type, {
                    name: type.name.replace(/ *\[[^\]]*]/, "").trim(),
                });
            });

            //set a default order type if ther eis one
            if (default_order_type.enabled) {
                this.type = parseInt(default_order_type.plunetId);
            }

            this.orderDetailsOptions = Object.assign(
                {},
                this.orderDetailsOptions,
                {
                    tags,
                    types,
                    order_numbers: order_numbers || [],
                    po_required: parseInt(po_required),
                    order_type_required: parseInt(order_type_required),
                    programs,
                    tag_settings,
                    tag_required: tag_settings.tag_required,
                    default_order_type,
                }
            );
        });
    },
    mounted() {
        this.setToken(document.querySelector("#token").content);
    },
    components: {
        CoStep,
        OnBehalf,
        ProgramDetails,
        Budget,
        SelectLanguages,
        DeliveryOptions,
        Automation,
    },
    computed: {
        ...mapState({
            store: (state) => state.CreateProgramStore,
            user: (state) => state.AuthStore.user,
        }),
        ...mapGetters("AuthStore", ["isAdminUser"]),
    },
    methods: {
        getProgramDetailsOptions() {
            return axios
                .get("/create-order/order-details/options")
                .then((result) => result.data);
        },
        ...mapMutations("CreateProgramStore", [
            "setNamingConvention",
            "setType",
            "setDescription",
            "setPurchaseOrderNumbers",
            "setTags",
            "setBudgetAmount",
            "setQuote",
            "setAutoApprove",
            "setAutoApproveAmount",
            "setUploadFileType",
            "setSchedulerEnabled",
            "setSourceLanguages",
            "setFilesUploading",
            "setSourceLanguage",
            "setSourceLanguageDescription",
            "setTargetLanguages",
            "setSchedulerIntervalHours",
            "setSchedulerPickUpTime",
            "setSchedulerNewOrderStatus",
            "setSchedulerStartedAt",
            "setSchedulerEnd",
            "setSchedulerEndsAt",
            "setSchedulerConnectorId",
            "setSchedulerSourceFolderId",
            "setSchedulerSourceFolderName",
            "setSchedulerTargetFolderId",
            "setSchedulerTargetFolderName",
            "setDeliveryOptionsNotifyOnOrderSubmit",
            "setDeliveryOptionsNotifyOnNewComment",
            "setDeliveryOptionsNotifyOnQuoteReady",
            "setDeliveryOptionsNotifyOnOrderComplete",
            "setDeliveryOptionsEmailFileDone",
            "setDeliveryOptionsEmailsToNotify",
            "setDeliveryOptionsConnectorDeliveryMethod",
            "setDeliveryOptionsComment",
            "setOnBehalfAccount",
            "setOnBehalfUser",
            "setToken",
        ]),
        addEmailToNotify(email) {
            // Access the child component (delivery option component) and update emails_to_notify
            this.$refs.deliveryOptionsComponent.emails_to_notify.push(email);
        },
    },
};
</script>

<style scoped></style>
